module.exports = __webpack_public_path__ + "assets/chicago@2x.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/chicago@2x.jpg
 ** module id = 204
 ** module chunks = 1
 **/